import React from 'react';
import { DatePickerBox } from '../../components/common';
import { BUTTON } from '../../constants';
import { capitalize } from '../misc';
export const billDataCompiler = (data) => {
  let finalData = [];
  data.map((obj) => {
    let billData = {
      id : obj?.id,
      url: obj.name.replaceAll('/', '_'),
      name: obj.name,
      draft_number: obj.draft_number || 'N/A',
      source: capitalize(obj?.ref) || obj.invoice_origin || 'N/A',
      invoice_date: obj.invoice_date || 'N/A',
      invoice_date_due: obj.invoice_date_due || 'N/A',
      state: capitalize(obj.state),
      amount_residual_signed: Math.abs(obj.amount_residual_signed).toFixed(2),
      lot: obj.invoice_line_ids[0]?.future_lot || 'N/A',
      ref : capitalize(obj?.ref) || 'N/A',
      container_no: obj?.container_no || 'N/A',
      invoice_no: obj?.invoice_number || 'N/A',
      data: obj,
    };
    finalData.push(billData);
  });
  return finalData;
};

export const billDetailsCompiler = (data) => {
  let finalData = [];
  data.map((obj) => {
    let billDetailsData = {
      product: obj.name,
      variant_size: obj?.product_id?.variant_size || 'N/A',
      variant_color: obj?.product_id?.variant_color || 'N/A',
      qty: obj.quantity,
      type: obj.product_id?.name,
      lot_no: obj?.future_lot || 'N/A',
      uom: obj.product_uom_id.name,
      unit_price: obj.price_unit,
      tax: obj?.tax_ids?.[0]?.name || 0,
      subtotal: obj.price_subtotal.toFixed(2),
      vendor_cost_line_id: obj?.id,
    };
    finalData.push(billDetailsData);
  });
  return finalData;
};

export function billsDetailBox(bill) {
  let detailBoxData = [
    { name: 'Bill No', col: 1, data: bill?.draft_number || 'N/A' },
    { name: 'Name', col: 1, data: bill?.partner_id?.name },
    { name: 'Source ', col: 1, data: capitalize(bill?.ref) || bill?.invoice_origin || 'N/A' },
    { name: 'Invoice No ', col: 1, data: bill?.invoice_number || 'N/A' },
    {
      name: 'Bill Date',
      col: 1,
      isCustom: bill?.state === 'draft' ? true : false,
      data: bill?.invoice_date,
      view: ({ value, setValue, clickHandler, showSave }) => {
        return (
          <div key={bill?.name} className="row mb-3">
            <div className="d-flex align-items-center justify-content-start">
              <div className="col-2 title">{'Bill Date'}</div>
              <div className="col-9 d-flex mx-2 align-items-center gap-3">
                <DatePickerBox
                  value={value}
                  setValue={setValue}
                  clickHandler={clickHandler}
                  showSave={showSave}
                  btnName={BUTTON.UPDATE}
                />
              </div>
            </div>
          </div>
        );
      },
    },
  ];
  return detailBoxData;
}
